<dynamic-form
  [apiName]="apiName"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [columns]="columns"
  (cancelChange)="cancel()"
  [group]="formGroup"
  (submitChange)="save()"
  [hasDefault]="false"
  (valueChangeByApiName)="valueChangeByApiName($event)"
  (valueChange)="onDynamicFormChanges($event)"
  (valueChangeWithName)="valueChangeWithName($event)">
  <ng-container class="footer">
    <div *ngIf="haserror" class="alert alert-danger">
      <div [hidden]="!haserror">
        {{ erroremessage }}
      </div>
    </div>
  </ng-container>
  <div class="content col-lg-12" if *ngIf="formGroup">
    <ssg-select
      name="Printers"
      [multiple]="!islightVersion"
      [group]="formGroup"
      [label]="'ClientApp.FrontOffice.PrintPolicy.Printers' | translate"
      [dataList]="PrinterList"
      textFieldName="Title"
      valueFieldName="Title"
      [repeatable]="!islightVersion"
      (valueChange)="valueChange()">
    </ssg-select>
    <ssg-select
      name="PrintTemplateId"
      [group]="formGroup"
      [label]="'ClientApp.FrontOffice.PrintPolicy.PrintTemplate' | translate"
      apiName="PrintTemplate/ReadPrintTemplateLookup"
      textFieldName="Title"
      valueFieldName="Id">
    </ssg-select>
    <ssg-select
      [class.disable-input]="customerPrint"
      name="Categories"
      class="categories"
      [multiple]="true"
      [group]="formGroup"
      [label]="'ClientApp.FrontOffice.PrintPolicy.ItemCategory' | translate"
      apiName="ItemCategory/ReadLookUp"
      textFieldName="Title"
      valueFieldName="Id"
      (valueChange)="valueChange()">
    </ssg-select>
    <ssg-select
      [class.disable-input]="customerPrint"
      name="Items"
      class="items"
      [multiple]="true"
      [group]="formGroup"
      [label]="'ClientApp.FrontOffice.PrintPolicy.Items' | translate"
      [dataList]="ItemWithCategory"
      textFieldName="Title"
      valueFieldName="Id"
      (valueChange)="valueChange()">
    </ssg-select>
    <ssg-select
      [class.disable-input]="customerPrint"
      name="IgnoredItems"
      [multiple]="true"
      [group]="formGroup"
      [label]="'ClientApp.FrontOffice.PrintPolicy.IgnoredItems' | translate"
      [dataList]="IgnoredItemsWithCategory"
      textFieldName="Title"
      valueFieldName="Id"
      (valueChange)="valueChange()">
    </ssg-select>
    <ssg-select
      name="SaleMethodBranches"
      [multiple]="true"
      [group]="formGroup"
      [label]="'ClientApp.FrontOffice.PrintPolicy.SaleMethods' | translate"
      apiName="SaleMethodBranch/ReadSaleMethodBranchLookUp"
      textFieldName="Title"
      valueFieldName="Id"
      (valueChange)="valueChange()">
    </ssg-select>
    <ssg-select
      name="Salons"
      [multiple]="true"
      [group]="formGroup"
      [label]="'ClientApp.FrontOffice.PrintPolicy.Salons' | translate"
      apiName="Salon/ReadLookUp"
      textFieldName="Title"
      valueFieldName="Id"
      (valueChange)="valueChange()">
    </ssg-select>
    <ssg-select
      [class.disable-input]="customerPrint"
      name="Dependents"
      [multiple]="true"
      [group]="formGroup"
      [label]="'ClientApp.FrontOffice.PrintPolicy.DependentPrintPolicy' | translate"
      [dataList]="PrintPolicyDependencies"
      textFieldName="Title"
      valueFieldName="Id"
      (valueChange)="valueChange()">
    </ssg-select>
  </div>
</dynamic-form>
